import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { LandingComponent } from '@modules/landing/pages/landing/landing.component';
import { EsriAuthGuard } from './core/guards/esri-auth.guard';
import { LandingAuthGuard } from './core/guards/landing-auth.guard';
import { UnauthorizedComponent } from './shared/components/unauthorized/unauthorized.component';


export const routes: Routes = [
  { path: '',         redirectTo: '/landing', pathMatch: 'full' },
  { path: 'landing',  component: LandingComponent, canActivate: [LandingAuthGuard] },
  { path: 'unauthorized', component: UnauthorizedComponent},
  {
    path: '',
    loadChildren: () => import('@modules/navigation-menu/navigation-menu.module')
    .then(m => m.NavigationMenuModule),
    canActivate: [EsriAuthGuard]
  },
  { path: '**',       redirectTo: '/landing' }
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule],
  providers: [
    EsriAuthGuard
  ]
})
export class AppRoutingModule { }
